import { api } from "../utils/api";
import type {
  RestCreateLayoutType,
  RestLayout,
  RestUpdateLayoutType,
} from "@KassaroAB/shared/types/layout";
import type { LayoutId } from "@KassaroAB/shared/types/ids";
import {
  catalogCollectionPath,
  type CatalogScope,
} from "./catalogScope";

const layoutsPath = (scope: CatalogScope) =>
  catalogCollectionPath(scope, "layouts");

export const getLayoutsApi = (scope: CatalogScope): Promise<RestLayout[]> => {
  return api.get(layoutsPath(scope));
};

export const getLayoutApi = (
  scope: CatalogScope,
  layoutId: LayoutId,
): Promise<RestLayout> => {
  return api.get(`${layoutsPath(scope)}/${layoutId}`);
};

export const createLayoutApi = (
  scope: CatalogScope,
  layout: RestCreateLayoutType,
): Promise<RestLayout> => {
  return api.post(layoutsPath(scope), layout);
};

export const updateLayoutApi = (
  scope: CatalogScope,
  layoutId: LayoutId,
  layout: RestUpdateLayoutType,
): Promise<RestLayout> => {
  return api.put(`${layoutsPath(scope)}/${layoutId}`, layout);
};

export const deleteLayoutApi = (
  scope: CatalogScope,
  layoutId: LayoutId,
): Promise<void> => {
  return api.delete(`${layoutsPath(scope)}/${layoutId}`);
};
